import { motion } from "framer-motion";

/**
 * Cinematic heading reveal — splits the text into words and animates
 * each one up from below a clip-path mask, with a small stagger.
 *
 * Pass `as` to render any heading element. Highlighted spans can be
 * inserted by splitting the prop into multiple `<AnimatedHeading>`
 * children, but for most cases passing a string is enough.
 */
export default function AnimatedHeading({
  text,
  as: Tag = "h1",
  className = "",
  delay = 0,
  highlight = null,
  highlightClass = "text-zinc-400",
  testid,
}) {
  const words = text.split(" ");
  return (
    <Tag data-testid={testid} className={className}>
      {words.map((w, i) => {
        const isHi = highlight && highlight.includes(w);
        return (
          <span
            key={i}
            className="inline-block overflow-hidden align-baseline"
            style={{ paddingBottom: "0.12em", marginBottom: "-0.12em" }}
          >
            <motion.span
              initial={{ y: "110%" }}
              whileInView={{ y: "0%" }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.8,
                delay: delay + i * 0.06,
                ease: [0.22, 0.61, 0.36, 1],
              }}
              className={`inline-block ${isHi ? highlightClass : ""}`}
            >
              {w}
              {i < words.length - 1 ? "\u00A0" : ""}
            </motion.span>
          </span>
        );
      })}
    </Tag>
  );
}
